"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.debounce = debounce, exports.isCached = void 0;

function debounce(a, b, c) {
  var d;
  return function () {
    var e = this,
        f = arguments;
    c && !d && a.apply(e, f), clearTimeout(d), d = setTimeout(function () {
      d = null, c || a.apply(e, f);
    }, b);
  };
}

var isCached = function isCached(a) {
  a = a.toLowerCase();
  var b = JSON.parse(sessionStorage.getItem(a.toLowerCase()));
  return b ? b : [];
};

exports.isCached = isCached;